import DpsProductListAccordian from './DpsProductListAccordian';

export default DpsProductListAccordian;
